import Icon from '@/components/Icon'
import { useSiteData } from '@/context/SiteDataProvider'
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import Link from 'next/link'
import styles from './Footer.module.scss'

function Footer() {
  const { footerMenuItems } = useSiteData()

  return (
    <footer className={styles.footer}>
      <div className={styles.decorativeInfiniti}></div>
      <div className={styles.footerContent}>
        <div className={styles.infoBlock}>
          <div className={styles.logo}>
            <Link href="/">
              <Image src="/logo.png" width={206} height={65} alt="Integrity Web Consulting logo" />
            </Link>
          </div>
          <div className={styles.contactInfo}>
            <ul>
              <li>
                <Icon icon={faEnvelope} className={styles.icons} />
                <Link
                  href="https://www.google.com/maps/place/Integrity+Web+Consulting/@38.6556784,-90.3035553,15z/data=!4m2!3m1!1s0x0:0xba0b10b8f718b364?sa=X&ved=1t:2428&ictx=111"
                  target="_blank"
                  rel="noreferrer"
                >
                  6358 Delmar Blvd, Suite #444 <br />
                  St Louis, MO 63130
                </Link>
              </li>
              <li>
                <Icon icon={faPhone} className={styles.icons} />
                <Link href="tel:314.727.3600" target="_blank" rel="noreferrer">
                  314.727.3600
                </Link>
              </li>
            </ul>
            <Link aria-label="LinkedIn" href="https://www.linkedin.com/company/integrity/" target="_blank" rel="noreferrer">
              <Icon icon={faLinkedinIn} className={styles.icons} />
            </Link>
            <Link aria-label="FaceBook" href="https://www.facebook.com/integritySTL/" target="_blank" rel="noreferrer">
              <Icon icon={faFacebookF} className={styles.icons} />
            </Link>
            <Link aria-label="Instagram" href="https://www.instagram.com/integrity_xd/" target="_blank" rel="noreferrer">
              <Icon icon={faInstagram} className={styles.icons} />
            </Link>
          </div>
        </div>

        <nav>
          <ul>
            {footerMenuItems.map((item) => (
              <li key={item.id} className={styles.parentItem}>
                <div className={styles.parentLink}>
                  {item.children.length ? <span>{item.label}</span> : <Link href={item.path}>{item.label}</Link>}
                </div>

                {item.children.length > 0 && (
                  <ul className={styles.submenu}>
                    {item.children.map((child) => (
                      <li key={child.id}>
                        <Link href={child.path}>{child.label}</Link>

                        {/* Check if this child has its own children (i.e., grandchildren) */}
                        {child.children?.length > 0 && (
                          <ul className={styles.grandchildMenu}>
                            {child.children.map((grandchild) => (
                              <li key={grandchild.id}>
                                <Link href={grandchild.path}>{grandchild.label}</Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className={styles.copyright}>
        <p>&copy; {new Date().getFullYear()} Integrity | All Rights Reserved</p>
        <p>
          <Link href="/terms-of-service">Terms of Use</Link> | <Link href="/privacy-policy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  )
}

export default Footer
